const GlobalDispatchMethods = Object.freeze({
  AddNotification: "Add_Notification",
  RemoveNotification: "Remove_Notification",
  ResetInitialState: "Reset_Initial_State",
  SetInitialState: "Set_Initial_State",
  SetSitemap: "Set_Sitemap",
  SitemapReset: "Sitemap_Reset",
  ToggleSideBar: "Toggle_SideBar",
});

export default GlobalDispatchMethods;
